import PropTypes from "prop-types";
import React, { useRef, useState } from "react";

export default function OtpCodeEntry(props) {
  const [otp, setOtp] = useState(Array(props.length).fill("")); // Array of empty strings
  const { onChange } = props;
  const inputRefs = useRef([]); // Array of refs for each input field
  const lastIndex = props.length - 1;

  const handleKeyDown = (e) => {
    const { target, key } = e;

    // Only handle key presses which are numeric or in a set of control keys for modifying the input
    const handledNonNumericKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];

    const isDigit = (input) => /^[0-9]{1}$/.test(input);
    if (!isDigit(key) && !handledNonNumericKeys.includes(key)) {
      return;
    }

    const selectedIndex = inputRefs.current.indexOf(target);
    
    if (e.key === "ArrowLeft") {
      if (selectedIndex > 0) {
        inputRefs.current[selectedIndex - 1].focus();
      }
      return;
    }
    if (e.key === "ArrowRight") {
      if (selectedIndex < lastIndex) {
        inputRefs.current[selectedIndex + 1].focus();
      }
      return;
    }

    if (
      !isDigit(key) &&
      e.key !== "Backspace" &&
      e.key !== "Delete" &&
      e.key !== "Tab" &&
      !e.metaKey
    ) {
      e.preventDefault();
    } else if (isDigit(key)) {
      if (key) {
        setOtp((prevOtp) => {
          prevOtp[selectedIndex] = key;
          return prevOtp;
        });
      }
      if (selectedIndex < lastIndex) {
        inputRefs.current[selectedIndex + 1].focus();
      }
    }

    if (e.key === "Delete" || e.key === "Backspace") {
        setOtp((prevOtp) => {
          prevOtp[selectedIndex] = ""
          return prevOtp;
        });
      if (selectedIndex > 0) {
        inputRefs.current[selectedIndex - 1].focus();
      }
    }
    if (typeof onChange === "function") {
      // Prevent stale value getting passed to callback.
      setTimeout(() => {
        onChange(otp.join(""));
      })
    }
  };

  const handleChange = () => {

  };
  const handleFocus = (e) => {
    e.target.select();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    let text = e.clipboardData.getData("text");
    // Remove all non-digit characters
    text = text.replaceAll(/\D+/g, "")
    // No digits, do nothing
    if (!text) {
      return;
    }
    // Correct number of digits, just fill the blanks
    if (text.length === props.length) {
      inputRefs.current[lastIndex].focus();
      setOtp(text.split(""));
      onChange(text);
      return;
    }
    // Set only the valid characters to the remaining boxes starting at selectedIndex
    const selectedIndex = inputRefs.current.indexOf(e.target);
    const displayArray = Array.from(otp);
    let counter = 0;
    let index = 0;
    for (const character of text) {
      index = selectedIndex + counter++;
      if (props.length > index) {
        displayArray[index] = character;
      } else {
        break;
      }
    }
    inputRefs.current[Math.min(index + 1, lastIndex)].focus();
    setOtp(displayArray);
    onChange(displayArray.join(""));
  };

  return (
    <div className="container">
      <form id="otp-form" className="flex gap-2">
        {otp.map((digit, index) => (
          <input
            id={"code&#8204;Input" + index}// The &#8204; is to confuse auto-complete
            key={index}
            type="text"
            maxLength={1}
            value={digit}
            autoFocus={index === 0}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onFocus={handleFocus}
            onPaste={handlePaste}
            autoComplete="off"
            ref={(element) => (inputRefs.current[index] = element)}
            className="shadow-xs flex w-[38px] items-center justify-center rounded-lg border border-stroke bg-transparent p-2 text-center text-2xl font-medium text-gray-5 outline-none sm:text-4xl border-gray-700 dark:bg-white/5"
          />
        ))}
      </form>
    </div>
  );
}

OtpCodeEntry.propTypes = {
  onChange: PropTypes.func.isRequired,
  length: PropTypes.number.isRequired
}